let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("jLkOD")).then(() => parcelRequire('d4GPM'));